// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as fetchGetHeaderReducer } from './fetchGetHeader';
import { reducer as fetchGetFooterReducer } from './fetchGetFooter';
import { reducer as fetchLoginReducer } from './fetchLogin';
import { reducer as fetchGetPhoneCodeReducer } from './fetchGetPhoneCode';
import { reducer as fetchRegisterReducer } from './fetchRegister';
import { reducer as fetchGetPhoneCodeByLoginReducer } from './fetchGetPhoneCodeByLogin';
import { reducer as fetchEditStuPwdReducer } from './fetchEditStuPwd';
import { reducer as fetchLoginByPhoneReducer } from './fetchLoginByPhone';
import { reducer as fetchGetConfigurationReducer } from './fetchGetConfiguration';
import { reducer as fetchConfigInfoReducer } from './fetchConfigInfo';
import { reducer as fetchStudentBasicsReducer } from './fetchStudentBasics';
import { reducer as fectchLoginOutReducer } from './fectchLoginOut';
import { reducer as fetchGetShoppingCarReducer } from './fetchGetShoppingCar';
import { reducer as addCartCountReducer } from './addCartCount';
import { reducer as clearCartCountReducer } from './clearCartCount';
import { reducer as fetchPutInCartsReducer } from './fetchPutInCarts';
import { reducer as fetchMoveOutCartsReducer } from './fetchMoveOutCarts';
import { reducer as fetchLogoutReducer } from './fetchLogout';
import { reducer as fetchFeedbackReducer } from './fetchFeedback';
import { reducer as fetchGetSearchDataReducer } from './fetchGetSearchData';
import { reducer as resetSearchTotalReducer } from './resetSearchTotal';
import { reducer as fetchGetWebSiteReducer } from './fetchGetWebSite';
import { reducer as fetchGetAdDefaultReducer } from './fetchGetAdDefault';
import { reducer as fetchGetWeAppCodeReducer } from './fetchGetWeAppCode';
import { reducer as fetchGetTeacherListReducer } from './fetchGetTeacherList';
import { reducer as fetchGetTeacherBannerReducer } from './fetchGetTeacherBanner';
import { reducer as fetchGetTeacherInfoReducer } from './fetchGetTeacherInfo';
import { reducer as fetchGetTeacherAnswerReducer } from './fetchGetTeacherAnswer';
import { reducer as fetchGetTeacherAboutReducer } from './fetchGetTeacherAbout';
import { reducer as delShoppingSuccessReducer } from './delShoppingSuccess';
import { reducer as fetchGetDefaultWxImgReducer } from './fetchGetDefaultWxImg';
import { reducer as fetchGetPublicAccountReducer } from './fetchGetPublicAccount';

const reducers = [
  fetchGetHeaderReducer,
  fetchGetFooterReducer,
  fetchLoginReducer,
  fetchGetPhoneCodeReducer,
  fetchRegisterReducer,
  fetchGetPhoneCodeByLoginReducer,
  fetchEditStuPwdReducer,
  fetchLoginByPhoneReducer,
  fetchGetConfigurationReducer,
  fetchConfigInfoReducer,
  fetchStudentBasicsReducer,
  fectchLoginOutReducer,
  fetchGetShoppingCarReducer,
  addCartCountReducer,
  clearCartCountReducer,
  fetchPutInCartsReducer,
  fetchMoveOutCartsReducer,
  fetchLogoutReducer,
  fetchFeedbackReducer,
  fetchGetSearchDataReducer,
  resetSearchTotalReducer,
  fetchGetWebSiteReducer,
  fetchGetAdDefaultReducer,
  fetchGetWeAppCodeReducer,
  fetchGetTeacherListReducer,
  fetchGetTeacherBannerReducer,
  fetchGetTeacherInfoReducer,
  fetchGetTeacherAnswerReducer,
  fetchGetTeacherAboutReducer,
  delShoppingSuccessReducer,
  fetchGetDefaultWxImgReducer,
  fetchGetPublicAccountReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/common/redux/reducer.js